module.exports = __webpack_public_path__ + "img/column_heading.a7f430cd.jpg";